import React, { useState, useEffect } from 'react'
import { Combo } from 'components'
import { fetchUrl } from 'modules/util/functions'

const SolicitudDePedidoCombo = (props) => {
    const [items, setItems] = useState([]);

    useEffect(() => {
        fetchUrl("/query/getsolicitudesDePedido", "get", {}, {
            success: (r) => {
                setItems(r.data.items.map(x => ({
                    value: x.idSolicitudDePedido,
                    label: x.label
                })));
            }
        }, { block: false });
    }, []);

    return (
        <Combo
            {...props}
            items={items} />
    )
}

export default SolicitudDePedidoCombo;

SolicitudDePedidoCombo.defaultProps = {
    formControl: true,
    formManaged: false
};